

import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "../styles/Google.css";
import pro1 from '../assets/images/pro1.png'
import pro2 from '../assets/images/pro2.png'
import pro6 from '../assets/images/pro3.png'
import pro3 from '../assets/images/pro4.png'
import pro5 from '../assets/images/pro5.png'

const ReviewText = ({ text, limit = 150 }) => {
  const [expanded, setExpanded] = useState(false);

  if (text.length <= limit) {
    return <p className="review-text">{text}</p>;
  }

  return (
    <p className="review-text">
      {expanded ? text : text.slice(0, limit) + "... "}
      <span
        className="read-more-less"
        style={{  cursor: 'pointer' }}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "Read Less" : "Read More"}
      </span>
    </p>
  );
};

const ReviewsSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerpadding: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    rtl: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

const handleHover = (index, isHovered) => {
  const reviewCard = document.getElementsByClassName("review-card")[index];
  if (!reviewCard) return; // exit if no card found

  const reviewerImg = reviewCard.querySelector(".reviewer-img");
  const reviewStars = reviewCard.querySelector(".review-stars");
  if (!reviewerImg || !reviewStars) return; // exit if elements missing

  if (isHovered) {
    reviewerImg.style.transform = "scale(1.1)";
    reviewStars.style.transform = "translateY(-5px)";
  } else {
    reviewerImg.style.transform = "scale(1)";
    reviewStars.style.transform = "translateY(0)";
  }
};


  useEffect(() => {
    const reviewCards = document.querySelectorAll(".review-card");
    reviewCards.forEach((card, index) => {
      card.style.opacity = "0";
      card.style.transform = "translateY(50px)";
      setTimeout(() => {
        card.style.opacity = "1";
        card.style.transform = "translateY(0)";
        card.style.transition = "all 0.5s ease";
      }, 200 * index);
    });
  }, []);

  return (
    <section className="reviews-section">
      <div className="reviews-pattern"></div>
      <div>
        <h2 className="section-title-test text-center mb-3">Our Happy Customers</h2>
        <div className="google-header">
          <div className="google-logo">
            <i className="fab fa-google"></i>
            <span>Reviews</span>
          </div>
          <div className="google-rating">
            <div className="google-stars">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star-half-alt"></i>
            </div>
            <div className="google-score">4.9/5</div>
          </div>
        </div>
        <div className="google-reviews-container">
          <Slider {...settings} className="reviews-slider">
            {/* Review 1 */}
            <div
              className="review-card"
              onMouseEnter={() => handleHover(0, true)}
              onMouseLeave={() => handleHover(0, false)}
            >
              <div className="review-header">
                <img src={pro1} alt="Sarah Johnson" className="reviewer-img" />
                <div className="reviewer-info">
                  <h4>Sanju San</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
              <div className="review-stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <ReviewText text="I visited Haronics recently, and Harshith was very cooperative and welcoming. Their cold-pressed oils, like coconut and other stuffs, are fresh, pure, and ideal for cooking or skincare. The toasted coconut chips are light, crunchy, and naturally sweet—perfect for a healthy snack. I highly suggest you visit if you want to taste truly natural chips and oils. Highly recommend!" />
              {/* <p className="review-date">Posted on: June 15, 2023</p> */}
            </div>

            {/* Review 2 */}
            <div
              className="review-card"
              onMouseEnter={() => handleHover(1, true)}
              onMouseLeave={() => handleHover(1, false)}
            >
              <div className="review-header">
                <img src={pro2} alt="Michael Chen" className="reviewer-img" />
                <div className="reviewer-info">
                  <h4>Akash C</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
              <div className="review-stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <ReviewText text="Best staff at service and thier knowledgable behaviour towards customers makes the shopping experience even memorable… special thanks to Vidya and Deepika for their dedication towards customer satisfaction 👍🏼" />
              {/* <p className="review-date">Posted on: July 3, 2023</p> */}
            </div>

            {/* Review 3 */}


            <div
              className="review-card"
              onMouseEnter={() => handleHover(1, true)}
              onMouseLeave={() => handleHover(1, false)}
            >
              <div className="review-header">
                <img src={pro3} alt="Michael Chen" className="reviewer-img" />
                <div className="reviewer-info">
                  <h4>Hithashree J</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
              <div className="review-stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <ReviewText text="I had so many chips In my life, for the first time I had coconut chips, it's a great experience to me. Now I want to try all the products of Haronics ... thank you for good services and healthy products.." />
              {/* <p className="review-date">Posted on: July 3, 2023</p> */}
            </div>

            {/* Review 4 */}
            <div
              className="review-card"
              onMouseEnter={() => handleHover(3, true)}
              onMouseLeave={() => handleHover(3, false)}
            >
              <div className="review-header">
                <img src={pro6} alt="Michael Chen" className="reviewer-img" />
                <div className="reviewer-info">
                  <h4>Shweta Agrawal</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
              <div className="review-stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <ReviewText text="Amazing products very good quality with reasonable price" />
              {/* <p className="review-date">Posted on: July 3, 2023</p> */}
            </div>

            {/* Review 5 */}
            <div
              className="review-card"
              onMouseEnter={() => handleHover(4, true)}
              onMouseLeave={() => handleHover(4, false)}
            >
              <div className="review-header">
                <img src={pro5} alt="Michael Chen" className="reviewer-img" />
                <div className="reviewer-info">
                  <h4>Akbar Hussain</h4>
                  <p>Verified Customer</p>
                </div>
              </div>
              <div className="review-stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <ReviewText text="Good and well hygienic product, I appreciate there service. I recommend each and every one to buy there organic products. Thank you so much Mr. Harshit (Founder & CEO) Good Job, keep it up." />
              {/* <p className="review-date">Posted on: July 3, 2023</p> */}
            </div>
          </Slider>
        </div>
        <div className="google-badge">
          <a href="https://g.co/kgs/ETJ8Eg3" target="blank" className="badge-btn" rel="noreferrer">
            <i className="fab fa-google"></i>
            See All Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;


